<template>
  <a-modal
    :visible="visible"
    title="导入Excel数据"
    @cancel="handleCancelParent"
    >
    <a-steps :current="currentStep">
      <a-step>
        <template slot="title">
          下载模板
        </template>
        <span slot="description">下载指定Excel模板</span>
      </a-step>
      <a-step>
        <template slot="title">
          上传Excel并导入
        </template>
        <span slot="description">上传填写后的模板文件</span>
      </a-step>
    </a-steps>
    <div v-if="currentStep == 0" class="steps-content">
      <a-button type="primary" @click="handleDownload">点击下载</a-button>
    </div>
    <div v-if="currentStep == 1" class="steps-content">
      <a-upload
        accept=".xlsx"
        :fileList="fileList"
        :beforeUpload="beforeUpload"
        :remove="handleRemove">
        <a-button type="primary">选择文件</a-button>
      </a-upload>
    </div>

    <template slot="footer">
      <a-button key="back" @click="handleCancelParent">取消</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        {{currentStep === 0 ? '下一步' : '导入'}}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    markerSetId: String,
  },
  data() {
    return {
      currentStep: 0,
      fileList: [],
      loading: false,
    };
  },
  methods: {
    handleCancelParent() {
      this.$emit('update:visible', false);
    },
    async handleOk() {
      if (this.currentStep === 0) {
        this.currentStep = 1;
      } else if (this.currentStep === 1) {
        // 导入
        if (this.fileList.length === 0) {
          this.$message.warning('请先选择文件');
          return;
        }
        const formData = new FormData();
        formData.append('file', this.fileList[0]);
        formData.append('markerSetId', this.markerSetId);
        try {
          this.loading = true;
          await this.$api.importAndExport.importFromExcel(formData, {
            // 导入比较耗时，加长超时时间
            timeout: 180000,
          });
          this.loading = false;
          this.$message.success('导入成功');
          this.fileList = [];
          this.$confirm({
            content: '导入成功，是否马上刷新？',
            onOk() {
              window.location.reload();
            },
            onCancel() {},
          });
        } catch (error) {
          this.loading = false;
          console.error(error);
        }
      }
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleDownload() {
      window.open('/file/数据导入模板.xlsx');
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 重置数据
        this.currentStep = 0;
      }
    },
  },
};
</script>

<style scoped>
.steps-content {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  * /deep/ .ant-upload-list {
    width: 200px;
    margin: 0 auto;
  }
</style>
